module.exports = "/images/10K-2T.webp?aa0ecd47039fe9a25d83b9526e99987e";